import { render } from "./AddParceiro.vue?vue&type=template&id=ba7227c6"
import script from "./AddParceiro.vue?vue&type=script&lang=js"
export * from "./AddParceiro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__